module.exports = __webpack_public_path__ + "media/images/article/2022_01-011e0a158f77aa4b895d6ac2c7166286.png";